/** Full-page navigation for absolute cross-app URLs (non–client-router redirects). */
export function assignLocation(url: string): void {
  globalThis.location.href = url
}
